import {
  ACCOUNT_DETAIL_REQUEST,
  CANCEL_EMAIL_CHANGE_REQUEST,
  RESEND_CONFIRMATION_EMAIL_REQUEST,
  RESET_PASSWORD_REQUEST,
  SET_LOCALE_REQUEST,
  REQUEST_TRAINING_DASHBOARD_TOKEN,
  GET_FLEET_DASHBOARD_LINK,
  GENERATE_API_KEY_REQUEST,
  GET_API_KEY_REQUEST,
  GET_JOB_PROFILE_REQUEST
} from './constants';

export function getAccountData(payload) {
  return { type: ACCOUNT_DETAIL_REQUEST, payload };
}

export function resetPassword(payload) {
  return { type: RESET_PASSWORD_REQUEST, payload };
}
export function resendConfirmationEmail(payload) {
  return { type: RESEND_CONFIRMATION_EMAIL_REQUEST, payload };
}
export function cancelEmailChange(payload) {
  return { type: CANCEL_EMAIL_CHANGE_REQUEST, payload };
}

export function setLocale(payload) {
  return { type: SET_LOCALE_REQUEST, payload };
}

export function getTrainingDashboardToken() {
  return { type: REQUEST_TRAINING_DASHBOARD_TOKEN };
}

export function getFleetDashBoardLink() {
  return { type: GET_FLEET_DASHBOARD_LINK };
}

export function generateApiKey(payload) {
  return { type: GENERATE_API_KEY_REQUEST, payload };
}

export function getApiKey(payload) {
  return { type: GET_API_KEY_REQUEST, payload };
}

export function getJobProfileList(payload){
  return { type: GET_JOB_PROFILE_REQUEST, payload};
}
